module.exports = __webpack_public_path__ + "img/img-03@3x.8c8db4c3.png";